import { SDH_TRANSITION_DEPLOY_DATE } from '@weenat/client/dist/core/tours'
import { PersistedLightPop } from 'app/src/kit/Pop'
import { useUserContext } from 'app/userProvider'
import React from 'react'
import SDHTransitionTour from './SDHTransitionTour'

/**
 * Mounts the SDH transition tour only for users who joined before the SDH
 * cutover. Persistence (already dismissed / completed) is handled by
 * `PersistedLightPop` via the `tours` resource.
 *
 * Must be rendered inside `NewDeviceDashboard` — its presence already implies
 * the `sdh` feature flag is on, so this gate only filters on `joinedAt`.
 */
const SDHTransitionTourGate: React.FC = () => {
  const { me } = useUserContext()

  if (parseInt(me.joinedAt, 10) >= parseInt(SDH_TRANSITION_DEPLOY_DATE, 10)) return null

  return (
    <PersistedLightPop tourKey='sdh_transition'>
      <SDHTransitionTour />
    </PersistedLightPop>
  )
}

export default SDHTransitionTourGate
